export default {"src":"/_next/static/media/closeIconWhite.8f54d7a7.svg","height":14,"width":15,"blurWidth":0,"blurHeight":0};